<template lang="pug">
.modal.modal-sm.modal-lg.modal-md.modal-xs.fade(
  :id='id',
  tabindex='-1',
  :aria-labelledby='id',
  aria-hidden='true'
)
  .modal-dialog
    .modal-content.modal-component
      .modal-header.header
        slot(name='modal-header')
      .modal-body.d-flex.flex-column.gap-3
        slot(name='modal-body')
      .modal-footer
        slot(name='modal-footer')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'ModalVue',
    props: {
      id: {
        type: String,
        require: true,
      },
      idName: {
        type: String,
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .modal-component
    height: auto
    overflow-y: auto
  .header
    padding: 1rem
  .modal-content
    background-color: #FCFCFC
</style>
